const getStore = (store?: Storage) => {
  try {
    return store ?? sessionStorage;
  } catch {
    return undefined;
  }
};

export const getFromStorage = (key: string, store?: Storage) => {
  return getStore(store)?.getItem(key);
};

export const saveToStorage = (key: string, value: string, store?: Storage) => {
  return getStore(store)?.setItem(key, value);
};

export const removeFromStorage = (key: string, store?: Storage) => {
  return getStore(store)?.removeItem(key);
};
